import { Loader2, Check, AlertCircle } from 'lucide-react';

export type SaveState = 'idle' | 'saving' | 'saved' | 'error';

interface SaveStatusProps {
  state: SaveState;
}

export function SaveStatus({ state }: SaveStatusProps) {
  if (state === 'idle') return null;

  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      {state === 'saving' && (
        <>
          <Loader2 className="h-3 w-3 animate-spin" />
          <span>Guardando...</span>
        </>
      )}
      {state === 'saved' && (
        <>
          <Check className="h-3 w-3 text-green-500" />
          <span>Guardado</span>
        </>
      )}
      {state === 'error' && (
        <>
          <AlertCircle className="h-3 w-3 text-destructive" />
          <span>Error</span>
        </>
      )}
    </div>
  );
}
